import React from 'react';
import {
	StaticImage,
	GatsbyImage,
	IGatsbyImageData,
} from 'gatsby-plugin-image';
import { Button } from '../../atom/button/Button';
import * as VisuallyHidden from '@radix-ui/react-visually-hidden';
import clsx from 'clsx';
import './style.css';
import { Link } from 'gatsby';
import { Heading } from '../../atom/heading/Heading';
import { Paragraph } from '../../atom/paragraph/Paragraph';

const STROKE_WIDTH = 7;

export type ProductTileProps = {
	image: IGatsbyImageData;
	title: string;
	body: string;
	path: string;
	icon?: string;
	iconUrl?: string;
	ctaText?: string;
	ctaSrOnlyText?: string;
	tileClass?: string;
};

export const ProductIcon = ({ icon, size = 80 }) => {
	return (
		<>
			{icon === 'invoiceFinance' ? (
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width={size}
					height={size}
					viewBox="0 0 256 256"
					fill="none"
					id="my-svg"
				>
					<defs>
						<linearGradient id="gradient1">
							<stop className="stop1" offset="0%" stopColor="#8f66ff" />
							<stop className="stop2" offset="100%" stopColor="#3d12ff" />
						</linearGradient>
					</defs>
					<path
						d="M213.333 160V53.3333C213.333 41.5513 203.782 32 192 32H63.9998C52.2178 32 42.6665 41.5513 42.6665 53.3333V202.667C42.6665 214.449 52.2178 224 63.9998 224H149.333M213.333 160L149.333 224M213.333 160H170.667C158.884 160 149.333 169.551 149.333 181.333V224M85.3332 74.6667H170.667M85.3332 117.333H149.333M85.3332 160H117.333"
						stroke="#0b5fd3"
						strokeWidth={STROKE_WIDTH}
						strokeLinecap="round"
						strokeLinejoin="round"
						id="my-path"
						transform="translate(0,0) scale(1)"
					/>
				</svg>
			) : null}
			{icon === 'lowDocInvoiceFinance' ? (
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width={size}
					height={size}
					viewBox="0 0 256 256"
					fill="none"
					id="my-svg"
				>
					<defs>
						<linearGradient id="gradient1">
							<stop className="stop1" offset="0%" stopColor="#8f66ff" />
							<stop className="stop2" offset="100%" stopColor="#3d12ff" />
						</linearGradient>
					</defs>
					<path
						d="M224 128.001C224 181.02 181.019 224.001 128 224.001M224 128.001H202.667M224 128.001C224 116.78 222.075 106.01 218.537 96.0006M128 224.001C74.9807 224.001 32 181.02 32 128.001M128 224.001V202.667M32 128.001C32 74.9813 74.9807 32.0006 128 32.0006M32 128.001H53.3333M128 32.0006V53.3339M128 32.0006C156.432 32.0006 181.977 44.3603 199.555 64M128 85.3339V128.001L149.333 138.667M199.555 64V32.0006M199.555 64H170.667"
						stroke="#0b5fd3"
						strokeWidth={STROKE_WIDTH}
						strokeLinecap="round"
						strokeLinejoin="round"
						id="my-path"
						transform="translate(0,0) scale(1)"
					/>
				</svg>
			) : null}
			{icon === 'equipmentFinance' ? (
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width={size}
					height={size}
					viewBox="0 0 256 256"
					fill="none"
					id="my-svg"
				>
					<defs>
						<linearGradient id="gradient1">
							<stop className="stop1" offset="0%" stopColor="#8f66ff" />
							<stop className="stop2" offset="100%" stopColor="#3d12ff" />
						</linearGradient>
					</defs>
					<path
						d="M53.333 181.333H32.000V74.667C32.000 62.885 41.551 53.333 53.333 53.333H182.300C191.315 53.333 199.358 59.001 202.389 67.492L224.000 128.000V181.333H202.667M53.333 181.333C53.333 193.116 62.885 202.667 74.667 202.667C86.449 202.667 96.000 193.116 96.000 181.333M53.333 181.333C53.333 169.551 62.885 160.000 74.667 160.000C86.449 160.000 96.000 169.551 96.000 181.333M160.000 181.333H96.000M160.000 181.333C160.000 193.116 169.551 202.667 181.333 202.667C193.116 202.667 202.667 193.116 202.667 181.333M160.000 181.333C160.000 169.551 169.551 160.000 181.333 160.000C193.116 160.000 202.667 169.551 202.667 181.333M220.191 117.333H170.667C164.775 117.333 160.000 112.558 160.000 106.667V53.333"
						stroke="#0b5fd3"
						strokeWidth={STROKE_WIDTH}
						strokeLinecap="round"
						strokeLinejoin="round"
						id="my-path"
						transform="translate(0,0) scale(1)"
					/>
				</svg>
			) : null}
			{icon === 'tradeFinance' ? (
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width={size}
					height={size}
					viewBox="0 0 256 256"
					fill="none"
					id="my-svg"
				>
					<defs>
						<linearGradient id="gradient1">
							<stop className="stop1" offset="0%" stopColor="#8f66ff" />
							<stop className="stop2" offset="100%" stopColor="#3d12ff" />
						</linearGradient>
					</defs>
					<path
						d="M128 224C181.019 224 224 181.019 224 128C224 74.9807 181.019 32 128 32M128 224C74.9807 224 32 181.019 32 128C32 74.9807 74.9807 32 128 32M128 224C128 224 85.3333 202.667 85.3333 128C85.3333 53.3333 128 32 128 32M128 224C128 224 170.667 202.667 170.667 128C170.667 53.3333 128 32 128 32M37.4626 96H218.537M37.4626 160H218.537"
						stroke="#0b5fd3"
						strokeWidth={STROKE_WIDTH}
						id="my-path"
						transform="translate(0,0) scale(1)"
					/>
				</svg>
			) : null}
			{icon === 'payrollFinance' ? (
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width={size}
					height={size}
					viewBox="0 0 256 256"
					fill="none"
					id="my-svg"
				>
					<defs>
						<linearGradient id="gradient1">
							<stop className="stop1" offset="0%" stopColor="none" />
							<stop className="stop2" offset="100%" stopColor="none" />
						</linearGradient>
					</defs>
					<rect id="backgr" width={256} height={256} fill="none" rx={60} />
					<path
						d="M74.6667 53.3333L74.6667 32M128 53.3333V32M181.333 53.3333V32M32 85.3333H224M96 160L128 181.333L160 117.333M53.3333 213.333H202.667C214.449 213.333 224 203.782 224 192V64C224 52.2179 214.449 42.6667 202.667 42.6667H53.3333C41.5513 42.6667 32 52.2179 32 64V192C32 203.782 41.5513 213.333 53.3333 213.333Z"
						stroke="#0b5fd3"
						strokeWidth={STROKE_WIDTH}
						strokeLinecap="round"
						strokeLinejoin="round"
						id="my-path"
						transform="translate(0,0) scale(1)"
					/>
				</svg>
			) : null}
		</>
	);
};

export const ProductTile = ({
	image,
	title,
	body,
	path,
	icon,
	iconUrl,
	ctaText = 'Learn more',
	ctaSrOnlyText = 'about',
	tileClass,
}: ProductTileProps) => {
	return (
		<Link
			to={path}
			className={clsx('flex flex-col items-center text-center', tileClass)}
		>
			<figure className={'w-20 h-20 mb-5'}>
				{icon ? (
					<ProductIcon icon={icon} />
				) : iconUrl ? (
					<img src={iconUrl} alt="" />
				) : null}
			</figure>
			<Heading level="h3" className={'!text-body text-ep-navy mb-2'}>
				{title}
			</Heading>
			<Paragraph
				className={'text-body leading-snug text-ep-black flex-grow mb-4'}
			>
				{body}
			</Paragraph>
		</Link>
	);
};
